import { render } from "./ImgCodeVersion8_2.vue?vue&type=template&id=3ca1e300&scoped=true&ts=true"
import script from "./ImgCodeVersion8_2.vue?vue&type=script&lang=ts"
export * from "./ImgCodeVersion8_2.vue?vue&type=script&lang=ts"

import "./ImgCodeVersion8_2.vue?vue&type=style&index=0&id=3ca1e300&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3ca1e300"]])

export default __exports__